import React from "react";
import cssClasses from "./IndividualAllotmentDetails.module.css";
import { Box, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SiteVisitDetailModal = ({ open, handleClose, selectedSiteVisits }) => {
  return (
    <Modal
      open={open}
      onClose={() => handleClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.header}>
          <h1>Site-Visits</h1>
          <IconButton
            className={cssClasses.crossButton}
            onClick={() => handleClose()}
          >
            {" "}
            <CloseIcon />{" "}
          </IconButton>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            fontSize: "1.4rem",
            padding: "1rem",
            gap: "1.3rem",
          }}
        >
          {selectedSiteVisits?.map((val) => {
            return (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span style={{ fontSize: "1.6rem" }}>
                  {val?.projectId?.projectName}
                </span>
                <span>{getAgreementDateInFormat(val?.created_at)}</span>
              </div>
            );
          })}
        </div>
      </Box>
    </Modal>
  );
};

function getAgreementDateInFormat(time) {
  const dateInFormat =
    new Date(time).toDateString() +
    " " +
    new Date(time).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  // console.log(dateInFormat);
  if (dateInFormat !== "Invalid Date Invalid Date") return dateInFormat;
}

export default SiteVisitDetailModal;
